import { SubsectionEditView, SubsectionCreateView } from './views';
import BusinessIcon from '@material-ui/icons/Business';

export default {
  edit: SubsectionEditView,
  create: SubsectionCreateView,
  icon: BusinessIcon,
};
